import { RequirementDefinitionGeneralLiabilityFormValues } from "../../../../types";
import { formatLimit } from "./formatLimit";

export const getGeneralLiabilitySettings = (
  settings: Partial<RequirementDefinitionGeneralLiabilityFormValues>
): string[] => {
  const items: string[] = [];

  const coverageType =
    settings.coverageType === "claimsMade"
      ? "Occurrence + Claims-made"
      : "Occurrence only";
  items.push(`Policy type: ${coverageType}`);
  items.push(
    `Per-incident limit: ${formatLimit(settings.perIncidentLimitMinimum)}`
  );
  items.push(
    `Total coverage limit: ${formatLimit(settings.totalCoverageLimitMinimum)}`
  );

  if (settings.acceptWingspanMasterPolicy !== undefined) {
    items.push(
      `Wingspan Master Policy: ${settings.acceptWingspanMasterPolicy ? "Accepted" : "Not accepted"}`
    );
  }

  return items;
};
